import React,{Component} from 'react';
import ReactDOM from 'react-dom'
import PropTypes from 'prop-types';

import { injectStripe } from 'react-stripe-elements';
import {
  Button,
  Input,
  FormGroup,
  Label,
  Popover,
  PopoverBody
} from 'reactstrap';

import Form from '../Form';
import CreditCardForm from '../CreditCardForm';
import BillingInfoForm from '../BillingInfoForm';
import InformationSVG from '../../assets/information.svg';
import MoneyDisplay from '../MoneyDisplay';

import {
  validationMessagesFromStripeError,
  formatPaymentMethod
} from '../../../shared/utils';

import './PaymentForm.css';

const CREATE_NEW_PAYMENT_METHOD_OPTION = '__CREATE_NEW_PAYMENT_METHOD_OPTION__',
  CREATE_NEW_INVOICE_METHOD_OPTION = '__CREATE_NEW_INVOICE_METHOD_OPTION__',
  CREATE_NEW_ADJOY_PAYS_METHOD_OPTION = '__CREATE_NEW_ADJOY_PAYS_METHOD_OPTION__',
  CURRENT_BALANCE_METHOD_OPTION = '__CURRENT_BALANCE_METHOD_OPTION__';

class PaymentForm extends Component {
  constructor(){
    super();

    this.state = {
      selectedValue:null,
      validationMessages:{},
      isShowingCardInfoPopover:false,
      isShowingBillingPopover:false
    };
    this.saveButtonRef = React.createRef();
  }

  componentWillMount(){
    const {
      showSuperadminFeatures,
      activePaymentMethodId,
      existingPaymentMethods,
      allowCreateNewMethod,
      defaultPaymentMethodId,
      createFormOnly,
      accountBalance
    } = this.props;

    const availablePaymentMethods = existingPaymentMethods.filter((p) => showSuperadminFeatures || p.kind === 'card');

    if(createFormOnly){
      this.setState({selectedValue:CREATE_NEW_PAYMENT_METHOD_OPTION})
    } else if(activePaymentMethodId){
      this.setState({selectedValue:activePaymentMethodId});
    } else if(defaultPaymentMethodId){
      this.setState({selectedValue:defaultPaymentMethodId});
    } else if(accountBalance >0){
      this.setState({selectedValue:CURRENT_BALANCE_METHOD_OPTION});
    }else if(availablePaymentMethods && availablePaymentMethods.length > 0){
      this.setState({selectedValue:availablePaymentMethods[0].id})
    } else if(allowCreateNewMethod){
      this.setState({selectedValue:CREATE_NEW_PAYMENT_METHOD_OPTION})
    }
  }

  componentWillReceiveProps(nextProps){
    if(nextProps.activePaymentMethodId && this.props.activePaymentMethodId !== nextProps.activePaymentMethodId){
      this.setState({selectedValue:nextProps.activePaymentMethodId})
    }
  }

  handleCancelClick(event){
    event.preventDefault();
    this.props.onCancel();
  }

  handleSubmit(data){
    this.setState({validationMessages: []});
    const saveButton = ReactDOM.findDOMNode(this.saveButtonRef.current);
    console.log(saveButton)
    saveButton.setAttribute("disabled", "disabled")
    const validationMessages = {};

    if(data.paymentMethodId === CREATE_NEW_PAYMENT_METHOD_OPTION ){

      //VALIDATE INPUTS
      if(!data.name || data.name.length === 0){
        validationMessages['name'] = 'Name is required';
      }

      if(!data.address_city || data.address_city.length === 0){
        validationMessages['address_city'] = 'City is required';
      }

      if(!data.address_line1 || data.address_line1 === 0){
        validationMessages['address_line1'] = 'Address is required';
      }

      if(!data.address_state || data.address_state.length === 0){
        validationMessages['address_state'] = 'State is required';
      }

      if(!data.address_zip || data.address_zip.length === 0){
        validationMessages['address_zip'] = 'Zip code is required';
      }

      if(data.address_zip && (data.address_zip.length !== 5 || isNaN(parseInt(data.address_zip,10)))){
        validationMessages['address_zip'] = 'Zip code is invalid';
      }

      if(Object.keys(validationMessages).length > 0){
        this.setState({validationMessages:validationMessages});
        setTimeout(() => { saveButton.removeAttribute("disabled") }, 1000)
        return;
      } else {
        this.props.stripe.createToken({
          name: data.name,
          address_line1: data.address_line1,
          address_line2: data.address_line2,
          address_city: data.address_city,
          address_state: data.address_state,
          address_zip: data.address_zip,
          currency: 'usd'
        })
          .then((res) => {
            if (res.error) {
              this.setState({
                validationMessages: validationMessagesFromStripeError(res.error)
              });
              setTimeout(() => { saveButton.removeAttribute("disabled") }, 1000)
              return;
            }

            if (!res.token) {
              throw new Error('No token from Stripe');
            }

            this.props.onSubmit({
              paymentMethodId: CREATE_NEW_PAYMENT_METHOD_OPTION,
              token: res.token.id,
              last4: res.token.card.last4,
              kind: 'card'
            }).catch((error) => {
                console.warn('Failed to save payment method: ' + error);
                validationMessages['number'] = error && error.length > 0 ? error : "unknown error";
                this.setState({validationMessages: validationMessages});
                setTimeout(() => { saveButton.removeAttribute("disabled") }, 1000)
            })
          })
      }


    } else if(data.paymentMethodId === CREATE_NEW_INVOICE_METHOD_OPTION){
      this.props.onSubmit({
        paymentMethodId:CREATE_NEW_INVOICE_METHOD_OPTION,
        token:null,
        last4:null,
        kind:'invoice'
      });

    } else if(data.paymentMethodId === CREATE_NEW_ADJOY_PAYS_METHOD_OPTION){
      this.props.onSubmit({
        paymentMethodId:CREATE_NEW_ADJOY_PAYS_METHOD_OPTION,
        token:null,
        last4:null,
        kind:'adjoy'
      });

    } else {
      this.props.onSubmit({ paymentMethodId:data.paymentMethodId });
    }
  }

  render(){
    const {
      validationMessages,
      selectedValue,
      isShowingBillingPopover,
      isShowingCardInfoPopover
    } = this.state;

    const {
      createFormOnly,
      showSuperadminFeatures,
      existingPaymentMethods,
      label,
      allowCreateNewMethod,
      showCancelButton,
      cancelButtonText,
      saveButtonText,
      showPopovers,
      defaultPaymentMethodId,
      accountBalance
    } = this.props;

    const availablePaymentMethods = existingPaymentMethods
      .filter((p) => showSuperadminFeatures || p.kind === 'card')
      .sort((a,b) => a.id !== defaultPaymentMethodId);

    return (
      <div className='PaymentForm'>
        <Form onSubmit={(data) => this.handleSubmit(data)}>
          <FormGroup>
            <span></span>
            {label.length > 0 && (
              <Label>{label}</Label>
            )}
            {(allowCreateNewMethod || availablePaymentMethods.length > 0) && (
              <Input
                type='select'
                name='paymentMethodId'
                value={selectedValue}
                onChange={(e) => this.setState({selectedValue:e.target.value})}
                hidden={createFormOnly}
              >
                {availablePaymentMethods.map((p) => (
                  <option
                    key={p.id}
                    value={p.id}
                  >
                    {formatPaymentMethod(p)}
                  </option>
                ))}
                {allowCreateNewMethod && (
                  <option
                    key={CREATE_NEW_PAYMENT_METHOD_OPTION}
                    value={CREATE_NEW_PAYMENT_METHOD_OPTION}
                  >
                    New Card
                  </option>
                )}
                {showSuperadminFeatures && allowCreateNewMethod &&(
                  <option
                    key={CREATE_NEW_ADJOY_PAYS_METHOD_OPTION}
                    value={CREATE_NEW_ADJOY_PAYS_METHOD_OPTION}
                  >
                    New Downtime Dollars Pays
                  </option>
                )}
                {showSuperadminFeatures && allowCreateNewMethod && (
                  <option
                    key={CREATE_NEW_INVOICE_METHOD_OPTION}
                    value={CREATE_NEW_INVOICE_METHOD_OPTION}
                  >
                    New Invoice
                  </option>
                )}
              </Input>
            )}
          </FormGroup>
          {(selectedValue === CREATE_NEW_PAYMENT_METHOD_OPTION) && (
            <div>
              <h6>
                Card Info
                {showPopovers && (
                  <span>
                    &nbsp;&nbsp;
                    <img
                      alt='Card Info Information'
                      src={InformationSVG}
                      id='CardInfoInfoIcon'
                      onMouseEnter={() => this.setState({isShowingCardInfoPopover:true})}
                      onMouseLeave={() => this.setState({isShowingCardInfoPopover:false})}
                    />
                    <Popover
                      className='TooltipPopover'
                      isOpen={isShowingBillingPopover}
                      target='BillingNameAndAddressInfoIcon'
                      placement='right'
                    >
                      <PopoverBody>
                        Name as it appears on your card and billing address associated with this account
                      </PopoverBody>
                    </Popover>
                  </span>
                )}
              </h6>
              <CreditCardForm
                validationMessages={validationMessages}
              />
              <h6>
                Billing Name & Address
                {showPopovers && (
                  <span>
                    &nbsp;&nbsp;
                    <img
                      alt='Billing Name & Address Information'
                      src={InformationSVG}
                      id='BillingNameAndAddressInfoIcon'
                      onMouseEnter={() => this.setState({isShowingBillingPopover:true})}
                      onMouseLeave={() => this.setState({isShowingBillingPopover:false})}
                    />
                    <Popover
                      className='TooltipPopover'
                      isOpen={isShowingCardInfoPopover}
                      target='CardInfoInfoIcon'
                      placement='right'
                    >
                      <PopoverBody>
                        Credit or debit card details
                      </PopoverBody>
                    </Popover>
                  </span>
                )}
              </h6>
              <BillingInfoForm validationMessages={validationMessages}/>
            </div>
          )}
          {(allowCreateNewMethod || (availablePaymentMethods && availablePaymentMethods.length > 0)) && (
            <Button color='primary' ref={this.saveButtonRef}>
              {saveButtonText}
            </Button>
          )}
          {showCancelButton && (
            <Button
              color='secondary'
              className='pull-right'
              onClick={(e) => this.handleCancelClick(e)}
            >
              {cancelButtonText}
            </Button>
          )}
          {(!allowCreateNewMethod && availablePaymentMethods && availablePaymentMethods.length === 0) && (
            <span>None available</span>
          )}
        </Form>
      </div>
    )
  }
}


PaymentForm.propTypes = {
  accountBalance:PropTypes.number,
  existingPaymentMethods:PropTypes.arrayOf(PropTypes.any).isRequired,
  defaultPaymentMethodId:PropTypes.string,
  onSubmit:PropTypes.func,
  onCancel:PropTypes.func,
  showSuperadminFeatures:PropTypes.bool.isRequired,
  showPopovers:PropTypes.bool.isRequired,
  createFormOnly:PropTypes.bool.isRequired,
  saveButtonText:PropTypes.string.isRequired,
  cancelButtonText:PropTypes.string,
  showCancelButton:PropTypes.bool
};


PaymentForm.defaultProps = {
  existingPaymentMethods:[],
  defaultPaymentMethodId:null,
  showSuperadminFeatures:false,
  showPopovers:true,
  createFormOnly:false,
  allowCreateNewMethod:true,
  onSubmit:() => {},
  onCancel:() => {},
  label:'',
  saveButtonText:'Save',
  cancelButtonText:'Cancel'
};

const PaymentFormWithStripeInContext = injectStripe(PaymentForm);

export default PaymentFormWithStripeInContext;



// WEBPACK FOOTER //
// ./src/shared/components/PaymentForm/index.js